import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";
import { Verified } from "../components/Verified";
import { useState } from "react";

export function ProfilePage({ username }: { username: string }) {
  const profile = useApi(() => api.profile(username), [username]);
  const session = useApi(api.session, []);
  const posts = useApi(() => api.profilePosts(username), [username]);
  const [following, setFollowing] = useState<boolean | null>(null);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({ displayName: "", bio: "", website: "", location: "" });
  const [profileOverride, setProfileOverride] = useState<typeof profile.data | null>(null);
  if (profile.error) return <div className="state">Profile not found.</div>;
  const user = profileOverride || profile.data;
  const isSelf = user && session.data?.user?.id === user.id;
  const isFollowing = following ?? Boolean(user?.isFollowing);
  async function toggleFollow() {
    if (!user) return;
    if (!session.data?.user) {
      location.href = "/login";
      return;
    }
    setFollowing(!isFollowing);
    try {
      await api.follow(user.id, isFollowing);
    } catch {
      setFollowing(isFollowing);
    }
  }
  function openEditor() {
    if (!user) return;
    setDraft({ displayName: user.displayName, bio: user.bio, website: user.website, location: user.location });
    setEditing(true);
  }
  async function saveProfile(event: React.FormEvent) {
    event.preventDefault();
    const updated = await api.updateProfile(draft);
    setProfileOverride(updated);
    setEditing(false);
  }
  return (
    <section className="profile profile-phone">
      {user && <header className="profile-head"><div className="profile-banner"><span>@{user.username}</span><button>Verify account</button></div><div className="profile-card"><img src={user.avatarUrl} alt="" /><div><h1>{user.displayName}<Verified show={user.citizenVerified || user.verified} /></h1>{(user.citizenVerified || user.verified) && <span className="citizen-flag"><Verified show /> Verified citizen</span>}<p className="profile-stats"><strong>{user.followingCount}</strong> Following <strong>{user.followerCount + (following === true && !user.isFollowing ? 1 : following === false && user.isFollowing ? -1 : 0)}</strong> Followers <strong>{user.postCount}</strong> Pages</p><p>{user.bio}</p>{user.website && <a href={user.website}>{user.website}</a>}<div className="profile-actions">{isSelf ? <button onClick={openEditor}>Edit profile</button> : <button onClick={() => void toggleFollow()}>{isFollowing ? "Following" : "Follow"}</button>}<a className="secondary" href="/messages">Message</a></div></div></div></header>}
      <div className="tabs"><button className="selected">Posts</button><button>Replies</button><button>Inspired</button><button>Pages</button></div>
      <div className="profile-grid">{posts.data?.map((post) => <a href={`/p/${post.id}`} key={post.id}>{post.media[0] ? <img src={post.media[0].url} alt="" /> : <span>{post.caption}</span>}</a>)}</div>
      {editing && <div className="modal-backdrop"><form className="composer profile-editor" onSubmit={(event) => void saveProfile(event)}><header><strong>Edit profile</strong><button type="button" onClick={() => setEditing(false)}>Close</button></header><input value={draft.displayName} onChange={(event) => setDraft({ ...draft, displayName: event.target.value })} placeholder="Display name" /><input value={draft.location} onChange={(event) => setDraft({ ...draft, location: event.target.value })} placeholder="Location" /><input value={draft.website} onChange={(event) => setDraft({ ...draft, website: event.target.value })} placeholder="https://..." /><textarea value={draft.bio} onChange={(event) => setDraft({ ...draft, bio: event.target.value })} placeholder="Bio" /><button className="primary">Save</button></form></div>}
    </section>
  );
}
